export const cutPrefix = (selectedPrefix, inputValue) => {
  if (inputValue && inputValue.startsWith(selectedPrefix)) {
    return inputValue.replace(selectedPrefix, '')
  }
  return inputValue
}
